import { GetTransactionDetailsResponseDto } from '@sparling/financial-common'
import axios, { AxiosRequestConfig } from 'axios'

export const getTransactionDetails = async (
  { token, id }: { id: number } & { token: string },
  options: AxiosRequestConfig = {},
): Promise<GetTransactionDetailsResponseDto> => {
  const response = await axios.get<GetTransactionDetailsResponseDto>(
    `${process.env.REACT_APP_SERVER_URL}/crm/transaction/${id}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        ...options.headers,
      },
      ...options,
    },
  )
  return response.data
}
